export const STRINGS = {
  UNSUBSCRIBE: "Unsubscribe",
  MARK_AS_LEAD: "Mark as lead",
  SKIP_CONTACT: "skipcontact",
  SMALL_REPEAT: "repeat",
  ONE_FR: "1fr",
  ALPHANUMERIC:
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
  SMALL_DATE: "date",
  DATE: "Date",
  STATS_DATA: "stats_data",
  SMALL_ACTION: "action",
  ACTION: "Action",
  SMALL_REPLY: "reply",
  STEP_ID: "step_id",
  CAMPAIGN_ID: "campaign_id",
  VIEW_EMAIL: "View Email",
  SMALL_EMAIL: "email",
  VIEW_REPLY: "View Reply",
  ADD_TO_CRM: "Add to CRM",
  ADD_TO_CRM_CONFIRMATION: "Would you like to add this contact to your CRM?",
  STEP: "Step",
  COPYOF: "Copy of",
  GMAIL: "Gmail",
  TIMINGS: "Timings",
  SELECT_SEQ_LIST: "Sequence & List",
  STEP15: "Step 1 of 5",
  STEP25: "Step 2 of 5",
  STEP35: "Step 3 of 5",
  STEP45: "Step 4 of 5",
  STEP55: "Step 5 of 5",
  COMMON_NAME: "Name*",
  ENTER_CAMP_NAME: "Enter Campaign Name",
  UNSUB_TAG_LABEL: "Unsubscribe Tag",
  UNSUB_TAG_DESC:
    "Adds the unsubscribe line to every email in this campaign. Turn it off and the line is left out entirely.",
  ENABLE_TRACKING_LABEL: "Enable Tracking",
  ENABLE_TRACKING_DESC:
    "Tracks opens and link clicks. Turn it off and this campaign reports 0 opens and 0 clicks.",
  SENDVIA: "Send Via*",
  ESP: "esp",
  MAILGUN: "Mailgun",
  CONNECT_GOOGLE: "Connect Google",
  SMALL_FOLDER_NAME: "foldername",
  SMALL_EDITOR: "editor",
  HEAD: "head",
  DESC: "desc",
  SMALL_ACTIVE: "active",
  SMALL_DONE: "done",
  UNSEL: "unsel",
  SEQ_TOBE_USED: "Email Sequence",
  LIST_TOBE_USED: "Contact List",
  CUSTOMIZATION_KEYS: "Customization Keys",
  CUSTOMIZATION_KEYS_DESC:
    "These keys come from the contact list you picked. Choose the ones this campaign can use in its emails.",
  CUSTOMIZATION_KEYS_PEOPLE: "People",
  CUSTOMIZATION_KEYS_COMPANY: "Company",
  CUSTOMIZATION_KEYS_CUSTOM: "Custom",
  CUSTOMIZATION_KEYS_OTHER: "Other",
  CUSTOMIZATION_KEYS_SEARCH: "Search keys",
  CUSTOMIZATION_KEYS_SELECT_ALL: "Select all",
  CUSTOMIZATION_KEYS_CLEAR: "Clear",
  CUSTOMIZATION_KEYS_SELECTED: "selected",
  CUSTOMIZATION_KEYS_NO_MATCH: "No keys match that search",
  CUSTOMIZATION_KEYS_LOADING: "Loading keys from this list",
  CUSTOMIZATION_KEYS_ERROR: "Could not load the keys for this list.",
  CUSTOMIZATION_KEYS_RETRY: "Try again",
  CUSTOMIZATION_KEYS_NO_LIST:
    "Pick a contact list on the previous step and its keys show up here.",
  CUSTOMIZATION_KEYS_EMPTY: "This list has no keys to personalise with.",
  SKIPPED_CONTACTS: "Skipped Contacts",
  NO_CONTACT: "No Contacts Skipped",
  SCHEDULE_DATE: "Schedule Date",
  TIMEZONE: "Time Zone",
  DAYS: "Days",
  START_TIME: "Start Time",
  END_TIME: "End Time",
  EDIT: "Edit",
  PREVIEW: "Preview",
  STEP1: "Step 1:",
  CAM_NAME: "Campaign Name:",
  SENVIA: "Send Via:",
  STEP2: "Step 2:",
  SEQUEN: "Sequence:",
  LIS: "List:",
  STEP3: "Step 3:",
  SKPCON: "Skipped Contacts:",
  STEP4: "Step 4:",
  SCHDAT: "Schedule Date:",
  TMZN: "Time Zone:",
  DY: "Days:",
  CONTACTS: "Contacts",
  CONTACT: "Contact",
  CAMP_BASIC_DETAILS: "Campaign Basic Details",
  CREATE_CAMPAIGN: "Create Campaign",
  CAMPAIGN_DESCRIPTION: "Follow 5 simple Steps to create your campaign",
  CANCEL: "Cancel",
  SCHEDULE_CAMPAIGN: "Schedule Campaign",
  NEXT: "Next",
  BACK: "Back",
  CAMP_SIGNATURE_DROPPED_ONE:
    "has no signature, so it was removed from this campaign's senders.",
  CAMP_SIGNATURE_DROPPED_MANY:
    "selected mailboxes have no signature, so they were removed from this campaign's senders.",
  CAMP_SIGNATURE_ALL_MISSING:
    "None of the selected mailboxes have a signature. Add one, or pick a mailbox that already has a signature.",
  CAMP_SIGNATURE_GATE_TOOLTIP:
    "Mailboxes with no signature are left out of this campaign.",
  CAMP_SIGNATURE_CHECKING: "Checking mailbox signatures…",
  DEL: "del",
  SMALL_FILE: "file",
  FOLDEL: "foldDel",
  SMALL_FOLDER: "folder",
  CMFOL: "campaignfolder",
  SQFOL: "sequencefolder",
  BULK_DEL_TYPE: "foldListDel",
  DLSQ: "delSeq",
  CMBULKDEL: "campaignBulkDelete",
  LISTID: "_name",
  DELETE_SELECTED: "Delete",
  DELETE_BULK: "Are you sure you want to delete the selected",
  DELETE: "Delete",
  TEAM_ID: "team",
  PRIVATE_ID: "private",
  TEAM_LABEL: "My Team",
  PRIVATE_LABEL: "Private",
  TYPE_TEMP: "template",
  TEMPLATES: "Templates",
  ID: "_id",
  SMALL_CREATE: "create",
  EDIT_TEMPLATE: "Edit Email Template",
  CREATE_EMAIL_TEMPLATE: "Create Email Template",
  SIGNATURE_DETAILS: "signature-details",
  CREATE_TEMP: "createtemplate",
  TYPETEMPLATE: "Type Template name ",
  OWNER: "Owner",
  TEMPLATE_OWNER: "templateowner",
  FOLDER: "Folder",
  SHARED_WITH: "Shared with*",
  SUBJECT1: "Subject*",
  SUBJECT2: "Subject:",
  FOLDER_SUB: "foldersubject",
  SMALL_SUBJECT: "subject",
  BODY: "Body",
  FOLDER_BODY: "folderbody",
  TEMPLATE_PREVIEW: "tempatepreview",
  TO: "To:",
  PRMLDATA: "previewMailBodyData",
  SMALL_UNDEFINED: "undefined",
  SEND_TEST_MAIL: "Send test email",
  TEMP_UPDATE: "Update Template",
  SAVE_TEMP: "Save Template",
  SAVE_TEMPLATE: "savetemplate",
  EMAIL_TEMPLATE: "Email Template",
  TEMPLATE_NAME1: "Template Name*",
  DEL_CONFIRM1: "Are you sure you want to Delete this Folder?",
  DEL_CONFIRM: "Are you sure you want to Delete this Template?",
  CLONE_SEQUENCE: "Clone Sequence",
  EDIT_SEQUENCE: "Edit Sequence",
  CREATE_SEQ: "Create Sequence",
  TYPESEQUENCE: "Type Sequence name",
  SHARE_FOLDER: "sharefolder",
  SMALL_CLONE: "clone",
  CLONE: "Clone",
  UPDATE: "Update",
  CREATE: "Create",
  FLODER_UPDATE: "floderupdate",
  TYPE_CAMP: "campaign",
  EDIT_FOLD: "Edit Folder",
  CREATE_FOLDER: "Create Folder",
  ENTER_FOLDER: "Enter Folder Name*",
  ENTER_FOLDER_PLACEHODER: "Type Folder Name",
  LIST_REMT: "listRemove",
  TEMP_REM: "templateRemove",
  REM_SEQ: "sequenceRemove",
  REM_CAM: "campaignRemove",
  REM_SELECTED: "Remove selected",
  REM_DATA: "Are you sure you want to remove",
  FROM_FOLD: "from Folder",
  REMOVE: "Remove",
  UPDATE_LIST: "Edit List",
  CREATE_LISST: "Create List",
  LISTNAME: "Contact List Name*",
  TYPELIST: "Type Contact List name",
  DELETE_CONFIRMATION: "Are you sure you want to Delete this",
  BODY2: "Body:",
  VIEW_MORE: "View more",
  VIEW_LESS: "View less",
  TITLE2: "Title:",
  NOTES2: "Notes:",
  CHOOSE_HEAD: "Choose a Step",
  CHOOSE_STEPS_TEXT:
    "Sequences are a series of outreach steps and activities designed to engage your prospects over time.",
  ADD: "Add",
  SMALL_EDIT: "edit",
  USER_SEQ_STEPS: "/user/sequence/steps/",
  CALL: "Call",
  SMALL_STEP: "step",
  INTERVALS: "Interval (in days)*",
  CALL_VAL: "Call contact to follow up",
  NOTES: "Notes",
  SAVE: "Save",
  NEW_TEMPLATE: "New Template",
  RE2: "Re:",
  AUTOMATED_EMAIL: "Automated email",
  TEMPLATE: "Template",
  ENTER_SUBJECT: "Enter Subject",
  TEMPLATE_NAME: "Template name:",
  SAVE_NEW_TEMPLATE: "Save as a new Template",
  TODO: "To Do",
  TASK_TITLE: "Task Title*",
  SENDMAIL: "Send mail to myself",
  RESET: "Reset",
  START_CAMP: "Start Campaign Now",
  START_TYPE: "startType",
  TYPE_SEQ: "Sequence",
  END_TYPE: "endType",
  CONNECT_OUTLOOK: "Connect Outlook",
  CONNECT_ZOHO: "Connect Zoho",
  AI_ASSISTANT: "ELI",
  YOUR_OFFERINGS: "Your Offerings/Services",
  CHALLENGES_FACED: "Challenges faced by your audience",
  SOLUTIONS: "Solutions",
  GET_STARTED: "Get Started with below functions",
  CONTEXT_TO_ADD: "Context to add",
  YOUR_OFFERINGS1: "Enter your services you offer in your product.",
  CHALLENGES_FACED1:
    "List all the challenges that your target customer encounters.",
  SOLUTIONS1:
    "Describe the solutions you offer to address your customer's problems.",
  GET_STARTED1: "Get Started with below functions",
  CONTEXT_TO_ADD1: "Please provide additional context",
  RESPONSE: "Response",
  ADD_TO_TEMPLATE: "Add to Template",
  COPY_ANSWER: "Copy Answer",
  GENERATE_RESPONSE: "Generate Response",
  AI_RESPONSE: "AI Response",
  CREDITS: "Credits",
  JOB_DESCRIPTION: "Job description",
  MEETING_BOOK: "Booked Meetings",
  WEBSITE_URL: "Website url",
  COPIED: "Copied",
  INCLUDE_GMAIL_SIGN: "Inlcude Gmail Signature",
  REQUIRED_FIELD: "This is a required field",
  CREDITS_AVAILABLE: "Credits Available:",
  DELIVER_OPTIMAL: "We deliver optimal results within a matter of",
  SECONDS: "seconds.",
  REGENERATE: "Regenerate",
  ANSWER_THE_PROMPTS: "Answer the Prompts",
  GET_THE_BEST: "Get the best preview results by filling in several",
  INPUT_LEFT: "inputs on the left",
  WORDS300: "(300 words)",
  SEND_CAMPAIGN_WITH: "Send campaign with",
  GENERATING: "Generating",
  MEETING_URL: "Meeting URL",
  GENERATE: "Generate",
  CREDIT10:
    "10 credits will be deducted. Are you sure you want to regenerate response?",
  TEST_EMAIL: "Test email will be delivered from your default mailbox to ",
  SELECT_TEMPLATE: "Select Template",
  ADD_TO: "Add to",
  WARNING: "Warning",
  PLEASE_WARNING: "Time will increase",
  OK: "Ok",
  EXTENDED:
    "We've extended the timeframe to ensure the success of the campaign.",
  ERROR: "error",
  DEFAULT: "default",
  STEPS: "steps",
  TYPESUBJECT: "Enter subject",
  EMAIL: "Email:",
  TASK_TTL: "Task Title",
  REGEN_RESP: "Regenerate Response",
  REQ_CRED: "Request for more credits",
  SUCCESS_REQ: "Request sent successfully",
  DEFINE_TARGET: "Define your target audience",
  IDENTIFY_YOUR:
    "Identify your ideal audience – their demographics, interests, and needs.",
  OUTLINE_SOLUTIONS: "Outline the solutions",
  ADDRESS_CHALLENGES:
    "Address the challenges you aim to resolve for your potential customers.",
  CURRENT_PROMO: "Current Promotional Offers(optional)",
  DO_YOU_HAVE: "Do you have any ongoing promotional offers?",
  ADD_INFO: "Additional information",
  FEEL_FREE:
    "Feel free to share any additional context or details you find relevant.",
  SELECT_EMAIL: "Select Email",
  SELECT_EMAIL_TOOLTIP:
    "Choose the connected email account that will be used to send this campaign.",
  SELECT_SIGNATURE: "Select signature",
  SELECT_SIGNATURE_TOOLTIP:
    "Pick the signature appended to every email in this campaign. \"Default Signature\" uses your campaign defaults.",
  DEF_SIGNATURE: "Default Signature",
  MARKETING: "Marketing",
  SUBJECT_SMALL: "subject",
  VIEW_PROFILE: "View Profile",
  PERSONAL_INFORMATION: "Personal Information",
  NOTAPPLICABLE: "N/A",
  COMPANY_INFORMATION: "Company Information",
  COMPANY_WEBSITE: "Company Website",
  ANNUAL_REVENUE: "annual_revenue",
  TECHNOLOGIES: "Technologies",
  VIEW_ALL: "View All",
  SHOW_MORE: "Show more...",
  SHOW_LESS: "Show less...",
  MOBILE_NUMBER: "Mobile Number",
  DIRECT_PHONE_NUMBER: "direct_phone_number",
  CORPORATE_NUMBER: "Corporate Number",
  PHONE_NUMBER: "Phone Number",
  COMPANY_PHONE_NUMBER: "company_phone_number",
  COPIED_TEXT_CNTR: "copiedTextContainer",
  SENT_SMALL: "sent",
  OPEN_SMALL: "open",
  ADD_AS_THREAD: "Add as thread",
  MATCH_ICP_PERSONA: "Match with ICP Persona",
  ICP_PERSONA_DESC:
    "Web-research each contact and score against your saved personas",
  COMPANY_PERSONA: "Company Persona",
  PERSON_PERSONA: "Person Persona",
  SELECT_COMPANY_PERSONA: "Select company persona...",
  SELECT_PERSON_PERSONA: "Select person persona...",
  // ICP Campaign Flow
  ICP_MATCHING_IN_PROGRESS: "ICP Matching in Progress",
  ANALYZING_CONTACTS: "Analyzing Contacts...",
  ICP_MATCHING_DESC: "Analyzing contacts against your Company personas",
  ICP_MATCHING_COMPLETE: "ICP Matching Complete",
  SET_THRESHOLD_CONTINUE: "Set Threshold & Continue",
  SET_ICP_THRESHOLD: "Set ICP Match Threshold",
  THRESHOLD_DESC:
    "Contacts scoring at or above this threshold will receive personalized outreach.",
  WILL_RECEIVE_OUTREACH: "Will receive outreach",
  WILL_BE_SKIPPED: "Will be skipped",
  REVIEW_SKIPPED: "Review Skipped Contacts",
  ADJUST_THRESHOLD: "Adjust Threshold",
  CONFIRM_PROCEED: "Confirm and Proceed",
  SETTING_UP_CAMPAIGN: "Setting up your campaign...",
  CAMPAIGN_SETUP_SUCCESS: "Campaign is being set up!",
  GO_TO_CAMPAIGN: "Go to Campaign",
  CONTACTS_SKIPPED: "Contacts Skipped",
  SKIP_REASON: "Skip Reason",
  THRESHOLD: "Threshold",
  SEARCHING_WEB: "Fetching company data from the web",
  SCRAPING_WEBSITES: "Scraping and analyzing company websites",
  MATCHING_COMPANY: "Matching against Company Persona criteria",
  MATCHING_PERSON: "Matching against Person Persona criteria",
  CALCULATING_SCORES: "Calculating combined match scores",
  MATCHING_COMPLETE_MSG: "ICP matching complete. Loading results...",
  NO_CONTACTS_MATCH:
    "No contacts meet this threshold. Lower the threshold to include more contacts.",
  CAMPAIGN_SETUP: "Campaign Setup",
  ANALYZING_DATA: "Analyzing Data",
  ICP_MATCHING: "ICP Matching",
  REVIEW_THRESHOLD: "Review & Threshold",
  PERSONALIZING: "Personalizing",
  SCHEDULE: "Schedule",
  ALL_CONTACTS_PASSED: "All contacts passed the threshold",
  RESEARCHING_CONTACTS: "Researching",
  CONTACTS_TEXT: "contacts",
  DEALBREAKER: "Dealbreaker",
  BACK_TO_CAMPAIGNS: "Back to Campaigns",
  CONNECTION_ISSUE: "Connection issue. Retrying in 30 seconds.",
  RETRY_NOW: "Retry Now",
  ALL_CONTACTS_TITLE: "All Contacts",
  SKIPPED_SUBTITLE: "Contacts Will Be Skipped (below {threshold}%)",
  CAMPAIGN_READY: "Campaign Ready",
  SET_THRESHOLD_BTN: "Set Threshold",
  // ICP Enhanced Detail View
  COMPANY_ANALYSIS: "Company Analysis",
  PERSON_ANALYSIS: "Person Analysis",
  OVERALL_SCORE: "Overall Score",
  CRITERIA_BREAKDOWN: "Criteria Breakdown",
  RESEARCH_EVIDENCE: "Research & Evidence",
  EVIDENCE: "Evidence",
  CONFIDENCE: "Confidence",
  NO_EVIDENCE_AVAILABLE: "No evidence available",
  MUST_HAVE: "Must Have",
  NICE_TO_HAVE: "Nice to Have",
  VIEW_DETAILS: "View Details",
  HIDE_DETAILS: "Hide Details",
  COMPANY_SUMMARY: "Company Summary",
  PERSON_SUMMARY: "Person Summary",
  COMPANY_LABEL: "Company",
  PERSON_LABEL: "Person",
  PERSONA_LABEL: "Persona",
  SKIP_REASONS_LABEL: "Skip Reasons",
  MATCHED_LABEL: "Matched",
  NOT_MATCHED_LABEL: "Not Matched",
  TOTAL_ANALYZED: "Total Analyzed",
  AVG_SCORE: "Avg. Score",
  HIGH_SCORERS: "High Scorers (70%+)",
  CONTACTS_ANALYZED: "contacts analyzed",
  ANSWER_LABEL: "Answer",
  REASON_FOR_SKIPPING: "Reason for skipping:",
  MATCH_DETAILS: "Match Details",
  WILL_RECEIVE_EMAIL: "Will receive personalized outreach",
  WILL_BE_SKIPPED_TEXT: "Will be skipped",
  TOTAL_RECORD_ANALYZED: "Total Records Analyzed",
  AVERAGE_MATCH_SCORE: "Average Match Score",
  HIGH_MATCH_COUNT: "High Match Count (70%+)",
  CAMPAIGNS: "Campaigns",
  ICP_VERIFICATION: "ICP Verification",
  // Pipeline unified screen
  PIPELINE_SETTING_UP: "Setting Up",
  PIPELINE_PERSONALIZING: "Personalizing",
  PIPELINE_SCHEDULING: "Scheduling",
  PIPELINE_READY: "Ready",
  PIPELINE_RUNNING: "Running",
  SETTING_UP_TITLE: "Setting Up Your Campaign",
  SETTING_UP_DESC:
    "Preparing your campaign infrastructure and validating contacts",
  PERSONALIZING_TITLE: "Personalizing Emails",
  PERSONALIZING_DESC: "Crafting unique messages tailored for each contact",
  SCHEDULING_TITLE: "Scheduling Delivery",
  SCHEDULING_DESC:
    "Optimizing send times across time zones for maximum engagement",
  CAMPAIGN_LIVE: "Campaign is Live",
  CAMPAIGN_LIVE_DESC:
    "Your campaign has been activated and emails are being delivered",
  CAMPAIGN_FINISH_READY: "All Set. Campaign Ready.",
  CAMPAIGN_FINISH_DESC:
    "Every contact has been verified, personalized, and scheduled",
  RESEARCHING_WEB: "Researching company and contact data across the web",
  GENERATING_CONTENT: "Generating personalized content for each contact",
  OPTIMIZING_SCHEDULE: "Finding optimal delivery windows",
  FINALIZING_SETUP: "Finalizing campaign configuration",
  // New pipeline step labels
  PIPELINE_ANALYZING: "Analyzing Data",
  PIPELINE_PERSONALIZING_DATA: "Personalizing Data",
  PIPELINE_PERSONALIZING_SCHEDULING: "Personalizing & Scheduling",
  PIPELINE_SCHEDULED: "Scheduled",
  PIPELINE_ACTIVE: "Active",
  PIPELINE_COMPLETED: "Completed",
  ANALYZING_TITLE: "Analyzing & Matching Data",
  ANALYZING_DESC: "Processing contacts against your ICP criteria",
};
